"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));

var _TextField = _interopRequireDefault(require("@sprinx/react-mui-fields/TextField"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _currencyFormatter = _interopRequireDefault(require("@sprinx/formatting/currencyFormatter"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      width: 313,
      position: 'absolute',
      right: 0,
      top: 0
    }, theme.breakpoints.down('sm'), {
      width: '100%',
      position: 'initial'
    }),
    slider: {},
    thumb: {},
    active: {},
    valueLabel: {},
    track: {},
    rail: {},
    label: {
      position: 'absolute',
      bottom: 0,
      border: '1px solid pink',
      '&:first-of-type': {
        left: 0
      },
      '&:last-of-type': {
        right: 0
      }
    },
    container: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    title: {
      display: 'flex',
      fontSize: 16,
      fontWeight: 500,
      paddingTop: theme.spacing(0.8),
      paddingBottom: theme.spacing(0.8),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    },
    priceContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& > span': {
        width: 'auto'
      }
    },
    textField: {
      width: 110,
      '& input': (0, _defineProperty2.default)({
        fontSize: 14
      }, theme.breakpoints.down('sm'), {
        fontSize: 16
      })
    }
  };
}, {
  name: 'SxFieldsPriceRangeSliderField'
});

var roundVals = function roundVals(_ref) {
  var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
      min = _ref2[0],
      max = _ref2[1];

  return [Math.floor(min), Math.ceil(max)];
};

var resetValue = function resetValue(value, minValue, maxValue) {
  return value || roundVals([minValue, maxValue]);
};

function PriceRangeSliderField(_ref3) {
  var pClasses = _ref3.classes,
      className = _ref3.className,
      currency = _ref3.currency,
      maxValue = _ref3.maxValue,
      minValue = _ref3.minValue,
      onChange = _ref3.onChange,
      value = _ref3.value,
      valueLabelDisplay = _ref3.valueLabelDisplay,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["classes", "className", "currency", "maxValue", "minValue", "onChange", "value", "valueLabelDisplay"]);
  var classes = useStyles({
    classes: pClasses
  });
  var theme = (0, _styles.useTheme)();
  var mobile = (0, _useMediaQuery.default)(theme.breakpoints.down('sm'));
  var t = (0, _useTranslate.default)();

  var _React$useState = _react.default.useState(resetValue(value, minValue, maxValue)),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      internalV = _React$useState2[0],
      setInternalV = _React$useState2[1];

  var _React$useState3 = _react.default.useState([false, false]),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      isFocused = _React$useState4[0],
      setIsFocused = _React$useState4[1];

  var handleChange = _react.default.useCallback(function (e, v) {
    onChange(v);
  }, [onChange]);

  _react.default.useEffect(function () {
    setInternalV(resetValue(value, minValue, maxValue));
  }, [maxValue, minValue, value]);

  var handleChangeField = _react.default.useCallback(function (i) {
    return function (newValue) {
      var newVals = internalV.map(function (val, index) {
        return index === i ? Number(newValue) : val;
      });
      setInternalV(newVals);
    };
  }, [internalV]);

  var handleBlurField = _react.default.useCallback(function () {
    var newVals = roundVals([Math.max(internalV[0], minValue), Math.min(internalV[1], maxValue)]);
    setInternalV(newVals);
    onChange(newVals);
    setIsFocused([false, false]);
  }, [internalV, maxValue, minValue, onChange]);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.root, className)
  }, mobile && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.title
  }, t('priceRangeSliderField/title')), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_Slider.default, (0, _extends2.default)({}, rest, {
    classes: {
      root: classes.slider,
      thumb: classes.thumb,
      active: classes.active,
      valueLabel: classes.valueLabel,
      track: classes.track,
      rail: classes.rail
    },
    valueLabelDisplay: valueLabelDisplay,
    value: internalV,
    min: Math.floor(minValue),
    max: Math.ceil(maxValue),
    onChange: function onChange(e, v) {
      return setInternalV(v);
    },
    onChangeCommitted: handleChange
  })), valueLabelDisplay === 'off' && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.priceContainer
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    className: classes.textField,
    variant: "outlined",
    value: isFocused[0] ? internalV[0] : (0, _currencyFormatter.default)(internalV[0], currency),
    onChange: handleChangeField(0),
    onBlur: handleBlurField,
    onFocus: function onFocus() {
      return setIsFocused([true, false]);
    }
  }), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    className: classes.textField,
    variant: "outlined",
    value: isFocused[1] ? internalV[1] : (0, _currencyFormatter.default)(internalV[1], currency),
    onChange: handleChangeField(1),
    onBlur: handleBlurField,
    onFocus: function onFocus() {
      return setIsFocused([false, true]);
    }
  }))));
}

process.env.NODE_ENV !== "production" ? PriceRangeSliderField.propTypes = {
  classes: _propTypes.default.shape({
    active: _propTypes.default.string,
    container: _propTypes.default.string,
    priceContainer: _propTypes.default.string,
    rail: _propTypes.default.string,
    root: _propTypes.default.string,
    slider: _propTypes.default.string,
    textField: _propTypes.default.string,
    thumb: _propTypes.default.string,
    title: _propTypes.default.string,
    track: _propTypes.default.string,
    valueLabel: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  currency: _propTypes.default.string.isRequired,
  maxValue: _propTypes.default.number,
  minValue: _propTypes.default.number,
  onChange: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
  valueLabelDisplay: _propTypes.default.oneOf(['auto', 'on', 'off'])
} : void 0;
PriceRangeSliderField.defaultProps = {
  classes: undefined,
  className: undefined,
  maxValue: undefined,
  minValue: undefined,
  onChange: undefined,
  value: undefined,
  valueLabelDisplay: 'off'
};
var _default = PriceRangeSliderField;
exports.default = _default;